import { render, staticRenderFns } from "./PositionsHeaderDashboard.vue?vue&type=template&id=b8b6045e"
import script from "./PositionsHeaderDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionsHeaderDashboard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports